import { render, staticRenderFns } from "./ConnectWalletDropdown.vue?vue&type=template&id=118cd5fc"
import script from "./ConnectWalletDropdown.vue?vue&type=script&lang=js"
export * from "./ConnectWalletDropdown.vue?vue&type=script&lang=js"
import style0 from "./ConnectWalletDropdown.vue?vue&type=style&index=0&id=118cd5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports